export default {
  intro: ['asset/logo.mp4', 'asset/fornir.mp3', 'asset/screen.jpg'],
  game: [
    'asset/shaman.mp4',
    'asset/death.mp4',
    'asset/small/viking_1.mp4',
    'asset/small/viking_2.mp4',
    'asset/small/viking_3.mp4',
    'asset/small/viking_4.mp4',
    'asset/small/viking_5.mp4',
    'asset/small/viking_6.mp4',
    'asset/small/viking_7.mp4',
    'asset/small/viking_8.mp4',
    'asset/small/viking_9.mp4',
    'asset/small/viking_10.mp4',
    'asset/small/viking_11.mp4',
    'asset/small/viking_12.mp4',
    'asset/small/viking_13.mp4',
    'asset/small/viking_14.mp4',
    'asset/small/viking_15.mp4',
    'asset/small/viking_16.mp4',
    'asset/small/viking_17.mp4',
    'asset/small/viking_18.mp4',
    'asset/small/viking_19.mp4',
    'asset/small/viking_20.mp4',
    'asset/small/viking_21.mp4',
    'asset/small/viking_22.mp4',
    'asset/small/viking_23.mp4',
    'asset/small/viking_24.mp4',
    'asset/small/viking_25.mp4',
    'asset/small/viking_26.mp4',
    'asset/small/viking_27.mp4',
    'asset/small/viking_28.mp4',
    'asset/thumbnail/viking_1.mp4',
    'asset/thumbnail/viking_2.mp4',
    'asset/thumbnail/viking_3.mp4',
    'asset/thumbnail/viking_4.mp4',
    'asset/thumbnail/viking_5.mp4',
    'asset/thumbnail/viking_6.mp4',
    'asset/thumbnail/viking_7.mp4',
    'asset/thumbnail/viking_8.mp4',
    'asset/thumbnail/viking_9.mp4',
    'asset/thumbnail/viking_10.mp4',
    'asset/thumbnail/viking_11.mp4',
    'asset/thumbnail/viking_12.mp4',
    'asset/thumbnail/viking_13.mp4',
    'asset/thumbnail/viking_14.mp4',
    'asset/thumbnail/viking_15.mp4',
    'asset/thumbnail/viking_16.mp4',
    'asset/thumbnail/viking_17.mp4',
    'asset/thumbnail/viking_18.mp4',
    'asset/thumbnail/viking_19.mp4',
    'asset/thumbnail/viking_20.mp4',
    'asset/thumbnail/viking_21.mp4',
    'asset/thumbnail/viking_22.mp4',
    'asset/thumbnail/viking_23.mp4',
    'asset/thumbnail/viking_24.mp4',
    'asset/thumbnail/viking_25.mp4',
    'asset/thumbnail/viking_26.mp4',
    'asset/thumbnail/viking_27.mp4',
    'asset/thumbnail/viking_28.mp4',
    'asset/sacrifice.mp3',
    'asset/no_sacrifice.mp3',
    'asset/ambient_loop.mp3',
  ],
};



// WEBPACK FOOTER //
// ./src/data/assets.ts